import { render, staticRenderFns } from "./BookingGoodsList.vue?vue&type=template&id=ad1497f6&scoped=true"
import script from "./BookingGoodsList.vue?vue&type=script&lang=js"
export * from "./BookingGoodsList.vue?vue&type=script&lang=js"
import style0 from "./BookingGoodsList.vue?vue&type=style&index=0&id=ad1497f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1497f6",
  null
  
)

export default component.exports